document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('quantity-input[data-pack-selector="true"]').forEach(packSelector => {
    const defaultQuantity = '12';
    const input = packSelector.querySelector('input[name="quantity-js"]');

    if (!input) return;

    // Définir 12 comme quantité par défaut
    input.value = defaultQuantity;

    // Transmettre immédiatement la quantité au formulaire Shopify
    eventBus.emit('qty:change', {
      value: defaultQuantity,
      sectionId: packSelector.getAttribute('data-section-id')
    });
  });
});

document.addEventListener('click', function (event) {
  const option = event.target.closest('.pack-option');

  if (!option) return;

  event.preventDefault();

  const packSelector = option.closest('quantity-input');
  if (!packSelector) return;

  const quantity = option.dataset.quantity;
  const input = packSelector.querySelector('input[name="quantity-js"]');

  if (!quantity || !input) return;

  input.value = quantity;

  packSelector.querySelectorAll('.pack-option').forEach(button => {
    button.classList.remove('is-selected');
  });

  option.classList.add('is-selected');

  eventBus.emit('qty:change', {
    value: quantity,
    sectionId: packSelector.getAttribute('data-section-id')
  });
});

eventBus.on('cart:added', function (data) {
  document.querySelectorAll(
    'quantity-input[data-pack-selector="true"]'
  ).forEach(packSelector => {
    const sectionId = packSelector.getAttribute('data-section-id');

    if (data.sectionId && data.sectionId !== sectionId) return;

    const input = packSelector.querySelector('input[name="quantity-js"]');

    if (!input) return;

    // Revenir à 12 unités
    input.value = '12';

    // Réactiver visuellement le bouton 12
    packSelector.querySelectorAll('.pack-option').forEach(button => {
      button.classList.toggle(
        'is-selected',
        button.dataset.quantity === '12'
      );
    });

    // Mettre également à jour la quantité réelle du formulaire
    eventBus.emit('qty:change', {
      value: '12',
      sectionId: sectionId
    });
  });
});